/**
 * 表格记录管理 Hook
 */

import { useState, useEffect } from "react";
import type { RecordData } from "../types";
import { createPlatformAdapter } from "../adapters/PlatformFactory";

export function useTableRecords(isReady: boolean = true) {
  const [records, setRecords] = useState<RecordData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const platform = createPlatformAdapter();

  /**
   * 加载当前表格的记录列表
   */
  const loadRecords = async () => {
    setLoading(true);
    setError(null);

    try {
      const table = await platform.getCurrentTable();

      const recordList = await platform.getRecords(table, { pageSize: 5000 });

      // 过滤空白记录（所有字段值都为空、null 或 undefined 的记录）
      const filteredRecords = recordList.filter((record) => {
        const values = Object.values(record.fields || {});
        // 至少有一个字段有值才保留
        return values.some((value) => {
          if (value === null || value === undefined) return false;
          if (typeof value === "string" && value.trim() === "") return false;
          return true;
        });
      });

      setRecords(filteredRecords);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "加载记录列表失败";
      setError(errorMessage);
      // 设置空数组而不是保持undefined
      setRecords([]);
    } finally {
      setLoading(false);
    }
  };

  // 组件挂载时加载记录列表（等待权限就绪）
  useEffect(() => {
    if (isReady) {
      loadRecords();
    }
  }, [isReady]);

  return {
    records,
    loading,
    error,
    reloadRecords: loadRecords,
  };
}
